import React, { Component } from 'react'
import NavigatorMain from '../NavigatorMain';
import {
    hashHistory
} from 'react-router';
import { AlerModleCommonn } from './AlerModle';
import { Wangqi } from "../../action/investmentAction"
import NHeader from "../NHeader.js";

export default class BaoGao extends Component {
  constructor(props) {
      super(props);
      this.state = {
        dataVals: null,
        tipFlag: false,
        texts: [],
        arrObjList: ""
      };
  }

  componentDidMount(){
    let dispatch = this.props.location.state.dispatch?this.props.location.state.dispatch:""
    let superFundCode = this.props.location.state.superFundCode
    dispatch(Wangqi({superFundCode:superFundCode},(val)=>{console.log(val), this.setState({arrObjList:val})}))
    
  }
  goBack(){
      hashHistory.goBack();
  }
  render() {
    let { arrObjList } = this.state
    return (
      <div>
        <NavigatorMain>
          <NHeader title="往期报告" isPaddingBottom={0} />
        </NavigatorMain>
        {
          arrObjList[0]!=undefined?
          arrObjList.map((v,i)=>{
            return <div key={i} style={{backgroundColor:"#ffffff",borderBottom:"0.02rem solid gray"}}>
                      <div style={{paddingBottom:"0.3rem",paddingTop:"0.3rem",fontSize:"0.28rem",paddingLeft:"0.3rem",paddingRight:"0.3rem"}}>{arrObjList[i].fundName?arrObjList[i].fundName:""}</div>
                      <div style={{WebkitFlexDirection:"row", display:"flex", WebkitJustifyContent:"space-between", WebkitAlignItems:"center",backgroundColor:"#ffffff",paddingLeft:"0.3rem",paddingRight:"0.3rem",fontSize:"0.24rem",color:"#666666"}}>
                          <div style={{flex:1}}>目标年化收益率</div>
                          <div style={{width:"2rem",display:"flex",justifyContent:"center"}}>运作年化<img alt='' src={require('../../img/smallWh.png')} style={{width:'0.3rem',marginLeft:"5px",marginTop:"-2px",height:"0.3rem"}} onClick={()=>{this.setState({tipFlag:true,texts:["运运作说明运作说明运作说明作说明"]})}}/></div>
                          <div style={{flex:1,display:"flex",justifyContent:"flex-end"}}>实际运行天数</div>
                      </div>
                      <div style={{WebkitFlexDirection:"row", display:"flex", WebkitJustifyContent:"space-between", WebkitAlignItems:"center",backgroundColor:"#ffffff",paddingLeft:"0.3rem",paddingRight:"0.3rem",paddingTop:"0.2rem",fontSize:"0.24rem",paddingBottom:"0.2rem"}}>
                        <div style={{flex:1,color:arrObjList[i].profitRate!=null?arrObjList[i].profitRate>=0?"#F8515C":"rgba(54, 169, 99, 1)":"#333333",fontWeight:"bold"}}>{arrObjList[i].profitRate!=null?(arrObjList[i].profitRate*100).toFixed(2)+"%":"--"}</div>
                        <div style={{width:"2rem",textAlign:"center",paddingRight:"0.3rem",color:arrObjList[i].operation?"#000000":arrObjList[i].annualizedGains!=null?arrObjList[i].annualizedGains>=0?"#F8515C":"rgba(54, 169, 99, 1)":"#333333",fontWeight:"bold",display:"flex",justifyContent:"center"}}>{arrObjList[i].operation?"运作中":arrObjList[i].annualizedGains!=null?(arrObjList[i].annualizedGains*100).toFixed(2)+'%':"--"}</div>
                        <div style={{flex:1,color:"#000000",fontWeight:"bold",display:"flex",justifyContent:"flex-end"}}>{arrObjList[i].operation?"运作中":arrObjList[i].operationDay!=null?arrObjList[i].operationDay+'天':"--"}</div>
                      </div>
                  </div>
          })
          :
          <div style={{WebkitFlexDirection:"row", display:"-webkit-flex", WebkitJustifyContent:"space-between", WebkitAlignItems:"center",backgroundColor:"#ffffff",paddingLeft:"0.3rem",paddingRight:"0.3rem",paddingTop:"0.2rem",paddingBottom:"0.2rem",color:"gray",fontSize:"0.24rem"}}>
            <div style={{paddingTop:"0.2rem",paddingBottom:"0.2rem",paddingLeft:"0.2rem",border:"0.02rem solid #D6DAE4",color:"#D6DAE4",backgroundColor:"#F6F7FA",flex:1,borderRadius:"0.1rem"}}>暂无往期报告。</div>
          </div>
        }
        {
            this.state.tipFlag?
             <AlerModleCommonn 
             btnTxt1="知道了"
             contentArr={this.state.texts}
             title="查理解密"
             handleClick1 = {()=>{this.setState({tipFlag:false})} }
           /> : null
          }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/fundDetail/BaoGao.js